import { SavingsFundRequestShow } from '@Resources/savings_funds_requests/SavingsFundRequestsShow';
import { ResourceDefinition } from '@Utils/types';

export const savingsFundsRequestsResource: ResourceDefinition = {
  options: { label: 'menu.savings_funds_requests' },
  show: SavingsFundRequestShow,
};
